/*============================================================================
  Iron — cross-sell panier ("Ajoutez à votre commande")
  - Remplit le bloc [data-iron-crosssell] dans le cart drawer.
  - Source : /recommendations/products.json (intent=complementary -> fallback related),
    basé sur le dernier produit ajouté, en excluant les articles déjà au panier.
  - Branché depuis theme.js (cartMarkup) via window.IronCrossSell.refresh(),
    + cart:updated en filet de sécurité.
  - Si l'utilisateur définit des complémentaires dans Search & Discovery,
    ils sont utilisés automatiquement (intent=complementary).
==============================================================================*/
(function () {
  if (window.IronCrossSell) return;

  var MAX_ITEMS = 3;

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var IronCrossSell = {
    busy: false,
    lastSig: '',

    root: function () { return document.querySelector('[data-iron-crosssell]'); },

    hide: function (root) {
      root = root || this.root();
      if (!root) return;
      root.hidden = true;
      root.dataset.rendered = 'false';
    },

    refresh: function () {
      var root = this.root();
      if (!root) return;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || !cart.items || cart.items.length === 0) {
            IronCrossSell.lastSig = '';
            IronCrossSell.hide(root);
            return;
          }
          var inCart = cart.items.map(function (i) { return i.product_id; });
          var sig = inCart.slice().sort(function (a, b) { return a - b; }).join(',');
          // Set de produits inchangé (ex. simple changement de quantité) -> on garde l'affichage.
          if (sig === IronCrossSell.lastSig && root.dataset.rendered === 'true') return;
          IronCrossSell.lastSig = sig;
          var seed = cart.items[cart.items.length - 1].product_id;
          IronCrossSell.loadRecs(root, seed, inCart);
        })
        .catch(function () { IronCrossSell.hide(root); });
    },

    loadRecs: function (root, seed, inCart) {
      var base = '/recommendations/products.json?product_id=' + seed + '&limit=10&intent=';
      fetch(base + 'complementary', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.products) || [];
          if (products.length) return products;
          return fetch(base + 'related', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (d) { return (d && d.products) || []; });
        })
        .then(function (products) {
          var filtered = products.filter(function (p) {
            return inCart.indexOf(p.id) === -1;
          }).slice(0, MAX_ITEMS);
          IronCrossSell.render(root, filtered);
        })
        .catch(function () { IronCrossSell.hide(root); });
    },

    render: function (root, products) {
      var list = root.querySelector('[data-iron-crosssell-list]');
      if (!list) return;
      if (!products || products.length === 0) { this.hide(root); return; }

      list.innerHTML = products.map(function (p) {
        var firstAvailable = null;
        if (p.variants && p.variants.length) {
          for (var i = 0; i < p.variants.length; i++) {
            if (p.variants[i].available) { firstAvailable = p.variants[i]; break; }
          }
        }
        var singleVariant = p.variants && p.variants.length === 1;
        var title = escapeHtml(p.title);
        var url = escapeHtml(p.url);
        var img = p.featured_image
          ? '<img class="iron-xsell__img" src="' + escapeHtml(sized(p.featured_image, 120)) + '" alt="" loading="lazy" width="44" height="44">'
          : '<span class="iron-xsell__img"></span>';

        var action;
        if (singleVariant && firstAvailable) {
          action = '<button type="button" class="iron-xsell__add" data-xsell-add="' + firstAvailable.id + '" aria-label="Ajouter ' + title + ' au panier">+</button>';
        } else {
          action = '<a class="iron-xsell__add iron-xsell__add--link" href="' + url + '" aria-label="Voir ' + title + '">&rsaquo;</a>';
        }

        return '<div class="iron-xsell__item">' + img +
          '<a class="iron-xsell__info" href="' + url + '">' +
          '<span class="iron-xsell__title">' + title + '</span>' +
          '<span class="iron-xsell__price">' + formatMoney(p.price) + '</span>' +
          '</a>' + action + '</div>';
      }).join('');

      root.hidden = false;
      root.dataset.rendered = 'true';
    },

    add: function (variantId, btn) {
      if (this.busy || !variantId) return;
      this.busy = true;
      if (btn) btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          IronCrossSell.busy = false;
          document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch(function () {
          IronCrossSell.busy = false;
          if (btn) btn.classList.remove('is-loading');
        });
    }
  };

  window.IronCrossSell = IronCrossSell;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-xsell-add]') : null;
    if (!btn) return;
    e.preventDefault();
    IronCrossSell.add(parseInt(btn.dataset.xsellAdd, 10), btn);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { IronCrossSell.refresh(); });
  } else {
    IronCrossSell.refresh();
  }

  // Filet de sécurité : l'évènement panier du thème (add / changement quantité).
  document.addEventListener('cart:updated', function () { IronCrossSell.refresh(); });
})();
